<template>
    <v-container>
        <v-row>
            <v-col align-self="center">
                <template v-if="collectivite.site_internet_texte">
                    <div v-html="collectivite.site_internet_texte"/>
                </template>
                <template v-else>
                    <default-text/>
                </template>
                <p v-if="collectivite.site_internet_pdf">
                    Téléchargez la délibération
                    <a :href="getDocumentsUrl(collectivite.site_internet_pdf)" class="link" download>
                        {{ collectivite.site_internet_pdf }}
                    </a>
                </p>
            </v-col>
            <template v-if="collectivite.site_internet_image">
                <v-col align-self="center" style="text-align: center;">
                    <img :src="getDocumentsUrl(collectivite.site_internet_image)" alt="">
                </v-col>
            </template>
            <template v-else>
                <default-images/>
            </template>
        </v-row>
    </v-container>
</template>

<script>
import { mapState } from 'vuex';
import { getDocumentsUrl } from '../../mixins';
import DefaultText from './DefaultText';
import DefaultImages from './DefaultImages';

export default {
    name: 'Introduction',
    components: { DefaultText, DefaultImages },
    mixins: [getDocumentsUrl],
    props: {},
    data() {
        return {};
    },
    computed: {
        ...mapState('collectivite', ['collectivite']),
    }, watch: {},
    created() {

    },
    methods: {},
}
</script>

<style scoped>
img {
    max-height: 70vh;
    max-width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Simulateur/IntroductionCollectivite.vue